module.exports = __webpack_public_path__ + "./Jenny_first2_2115ef6c6f3c318c24240eafaad8d74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Jenny_first2.png
// module id = 561
// module chunks = 0